import React, { Component } from "react";
import cn from "classnames";
import Layout from "./Layout";
import "./VerticalLayout.less";

const CLASS_NAME = "fct-vertical-layout";
const HORIZONTAL_ALIGN = {
  STRETCH: "_stretch",
  LEFT: "_left",
  CENTER: "_center",
  RIGHT: "_right"
};

class VerticalLayout extends Component {
  static defaultProps = {
    scrolly: true,
    horizontalAlign: HORIZONTAL_ALIGN.STRETCH
  };

  render() {
    const { children, horizontalAlign, className, ...props } = this.props;
    return (
      <Layout className={cn(CLASS_NAME, horizontalAlign, className)} {...props}>
        {this._renderChildren()}
      </Layout>
    );
  }

  _renderChildren() {
    const { lgap, rgap, tgap, bgap, hgap, vgap, children } = this.props;
    if (
      lgap == null &&
      rgap == null &&
      tgap == null &&
      bgap == null &&
      hgap == null &&
      vgap == null
    ) {
      return children;
    }
    return React.Children.map(children, (child, i) => {
      return React.cloneElement(child, {
        ...(lgap != null
          ? {
              _lgap: (lgap || 0) + (child.props._lgap || 0)
            }
          : {}),
        ...(rgap != null
          ? {
              _rgap: (rgap || 0) + (child.props._rgap || 0)
            }
          : {}),
        ...(tgap != null || vgap != null
          ? {
              _tgap:
                (i === 0 ? vgap || 0 : 0) +
                (tgap || 0) +
                (child.props._tgap || 0)
            }
          : {}),
        ...(bgap != null || vgap != null
          ? {
              _bgap: (vgap || 0) + (bgap || 0) + (child.props._bgap || 0)
            }
          : {}),
        ...(hgap != null
          ? {
              _hgap: (hgap || 0) + (child.props._hgap || 0)
            }
          : {})
      });
    });
  }
}
VerticalLayout.HORIZONTAL_ALIGN = HORIZONTAL_ALIGN;
export default VerticalLayout;



// WEBPACK FOOTER //
// ./layout/VerticalLayout.js